import { Spinner } from '../Spinner/Spinner';

export interface FullViewSpinnerProps {
  size?: string;
}

export function FullViewSpinner({ size }: FullViewSpinnerProps) {
  return (
    <div className="flex size-full items-center justify-center">
      <Spinner size={size} />
    </div>
  );
}
